import { render, staticRenderFns } from "./manage-profile.vue?vue&type=template&id=47b50aa9&scoped=true"
import script from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-profile.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./manage-profile.vue?vue&type=style&index=0&id=47b50aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b50aa9",
  null
  
)

export default component.exports